import * as yup from 'yup';

export const UpdateScientificAreaFormValidation = yup.object().shape({
    description: yup.string().required('Descrição é obrigatória'),
    id: yup.string().required('id é obrigatório'),
});